import React from "react";
import PropTypes from "prop-types";
import { DialogTitle, Stack, Typography } from "@mui/material";

import { HubButton } from "../inputs";
// import { HubIcon } from "../HubIcon";
// import { StyledStack } from "./styles";

export const HubDialogTitle = ({ onClose, leftContent = "", contextMenu }) => {
  //   const Icon = (
  //     <StyledStack>
  //       <HubIcon icon="Navigation2" />
  //     </StyledStack>
  //   );
  return (
    <DialogTitle>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        gap="20px"
        position="relative"
      >
        {leftContent &&
          (typeof leftContent === "string" ? (
            <Typography
              variant="dropDownText"
              sx={{
                textWrap: "nowrap",
              }}
            >
              {leftContent}
            </Typography>
          ) : (
            leftContent
          ))}
        <Stack direction="row" gap="10px">
          {contextMenu && contextMenu}
          {onClose && (
            <HubButton
              variant="text"
              color="neutral"
              icon="X"
              onClick={onClose}
              disableBackground
              sx={{ minWidth: 0 }}
            />
          )}
        </Stack>
      </Stack>
    </DialogTitle>
  );
};

HubDialogTitle.propTypes = {
  leftContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClose: PropTypes.func,
  contextMenu: PropTypes.node,
};
